// src/services/authService.js

import { API_BASE_URL } from './config';

async function parseResponseBody(response) {
  const contentType = response.headers.get('content-type') || '';
  const rawText = await response.text();

  if (!rawText) {
    return { data: null, rawText: '' };
  }

  if (contentType.includes('application/json')) {
    try {
      return { data: JSON.parse(rawText), rawText };
    } catch {
      return { data: null, rawText };
    }
  }

  try {
    return { data: JSON.parse(rawText), rawText };
  } catch {
    return { data: null, rawText };
  }
}

export const loginUser = async (credentials) => {
  try {
    const response = await fetch(`${API_BASE_URL}/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(credentials),
    });

    const { data, rawText } = await parseResponseBody(response);

    if (!response.ok) {
      const message =
        data?.message ||
        rawText ||
        `Login failed with status ${response.status}.`;
      throw new Error(message);
    }

    if (!data?.token) {
      throw new Error(
        `Unexpected login response from ${API_BASE_URL}/auth/login.`
      );
    }

    return data.token;
  } catch (error) {
    throw new Error(error.message || 'An unexpected error occurred');
  }
};
